/* eslint-disable import/prefer-default-export */
import * as yup from 'yup';

const CPISchema = yup.object().shape({
    description: yup.string()
        .trim()
        .required('Description is required.'),
    amount: yup.number()
        .nullable()
        .transform((value, originalValue) => {
            if (typeof originalValue === 'string' && originalValue.trim() === '') {
                return null;
            }
            return value;
        })
        .required('Amount is required.')
        .typeError('Amount is required.'),
    collectFirstCPIPaymentAtSigning: yup.boolean(),
    amountDueAtSigning: yup.number().nullable().transform((value, originalValue) => {
        if (typeof originalValue === 'string' && originalValue.trim() === '') {
            return null;
        }
        return value;
    }),
    frequency: yup.string().nullable(),
    firstDueDate: yup.date()
        .nullable()
        .required('First Due Date is required.')
        .typeError('First Due Date is required.'),
    lastDueDate: yup.date()
        .nullable()
        .required('Last Due Date is required.')
        .typeError('Last Due Date is required.'),
});

export {
    CPISchema,
};
